export default __webpack_public_path__ + "static/media/image.46a3bf7f.png";